(function () {
    'use strict';

    angular
        .module('adminGovernanceProcessControllers')
        .controller('AdminGovernanceProcessListController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'governanceProcesses', 'governanceProcessTypes'];

    function Controller($scope, $state, topBarService, governanceProcesses, governanceProcessTypes) {

        topBarService.setModule(undefined);
        topBarService.setTitleAndIcon('Manage Governance Processes', 'fa fa-road');

        $scope.governanceProcessTypes = governanceProcessTypes;
        $scope.governanceProcessesByType = _.groupBy(governanceProcesses, function (process) {
            return process.GovernanceProcessTypeID;
        });

        $scope.addProcess = function (processType) {
            $state.go('admin.governanceProcess.add',
                      { governanceProcessTypeValue: processType.Value });
        }
    }
})();